import { QueryClient, useQueryClient } from "react-query";
import { supabase } from "../../../supabaseClient";
import { UserPoints } from "../models/UserPoints";
import { queryClient } from "../../../App";

export const addPoints = async ({
  points,
  reason,
  userId,
  taskId,
  rockId,
}: {
  points: number;
  reason: string;
  userId: string | undefined;
  taskId?: number;
  rockId?: number;
}) => {
  if (!userId) {
    console.error("User ID is required to add points");
    return;
  }
  try {
    const newPoints: UserPoints = {
      created_at: new Date().toISOString(),
      user_id: userId!,
      reason: reason,
      value: points,
      task_id: taskId,
    };

    const { data: userPoints, error: userError } = await supabase
      .from("user_points")
      .insert(newPoints);

    const { data, error } = await supabase
      .from("users")
      .select("points")
      .eq("id", userId)
      .single();

    if (error) {
      console.error("Error retrieving point value:", error);
      return;
    }

    const currentValue = data.points;
    const incrementedValue = currentValue + points;

    console.log("incrementedValue", incrementedValue);

    queryClient.setQueryData("user_points", { points: incrementedValue });

    const { data: updatedData, error: updateError } = await supabase
      .from("users")
      .update({ points: incrementedValue })
      .eq("id", userId);

    if (updateError) {
      console.error("Error updating points value:", updateError);
      return;
    }

    console.log("Points value incremented successfully");
  } catch (error) {
    console.error("Error adding points:", error);
    throw error;
  }
};
